/** The app clock, re-read on an interval so freshness chips age without a store write. */
import { useEffect, useState } from 'react';
import { clockNow } from '@/state/store';

export function useNowMs(intervalMs: number = 5000, wallClock = false): number {
  const [now, setNow] = useState(() => ({ real: Date.now(), app: clockNow() }));
  useEffect(() => {
    const timer = window.setInterval(() => setNow({ real: Date.now(), app: clockNow() }), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return wallClock ? now.real : now.app;
}
